import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon } from '@mui/material';
import Faq from '../../components/controls/Faq';

const faqData = [
  {
    category: '',
    questions: [
      {
        question: '1. Hoe krijgt mijn organisatie toegang tot infraplannen.nl?',
        answer: `<p>
                  Bent u werkzaam bij een (semi)overheidsorganisatie zoals een gemeente, provincie of waterschap? Dan kan een deelnemende netbeheerder in uw gebied u uitnodigen voor infraplannen.nl. 
                  Neem daarvoor contact op met een van uw netbeheerders. Hebt u geen contactgegevens van uw netbeheerders voor deze vraag? Dan kunt u contact opnemen met <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>. 
                </p>
                <p>
                  Voor netbeheerders geldt dat er met alle deelnemers van Stichting Mijn Aansluiting contact is over infraplannen.nl.
                </p>
                <p>
                  Het aantal deelnemers op infraplannen.nl groeit snel. Bekijk de organisaties die actief zijn op <a href="https://status.infraplannen.nl" target="_blank" rel="noopener noreferrer">status.infraplannen.nl</a>.
                </p>`
      },
      {
        question: '2. Moet onze organisatie met de andere organisaties in de regio een samenwerkingsverband hebben voordat we toegang kunnen krijgen tot infraplannen.nl?',
        answer: `<p>
                  Een samenwerkingsverband integraal programmeren is geen voorwaarde om toegang te krijgen tot infraplannen.nl. Maar let op: het is noodzakelijk om onderlinge afspraken te maken over het inzien van elkaars plannen en de afstemming. 
                  Gebruik daarvoor de uniforme stappenplannen en formats van <a href="https://www.desamenwerkwijzer.nl" target="_blank" rel="noopener noreferrer">www.desamenwerkwijzer.nl</a>. 
                  Daarnaast kunnen adviseurs van Stichting Mijn Aansluiting ondersteunen bij het verkennen van de mogelijkheden. Neem contact op via <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>.
                </p>
                <p>
                  Weten in welke regio's er al samenwerkingsverbanden integraal programmeren actief zijn? Bekijk de actieve samenwerkingen. 
                </p>`
      },
      {
        question: '3. Hoe zorg ik dat ons eigen plansysteem gekoppeld wordt aan infraplannen.nl?',
        answer: `<p>
                  Nadat uw organisatie is uitgenodigd op infraplannen.nl door één van de deelnemende netbeheerders in uw regio, neemt Stichting Mijn Aansluiting contact met u op voor de onboarding van uw organisatie. 
                  Tijdens deze onboarding worden de verschillende opties van koppelen toegelicht. U kunt zich vast voorbereiden op de connectiviteit.
                </p>` 
                // <a href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/618463238/Technische+documentatie+infraplannen.nl" target="_blank" rel="noopener noreferrer">informatiepagina</a>
      },
      {
        question: '4. Hoe word ik key-user van infraplannen.nl vanuit mijn organisatie?',
        answer: `<p>
                  Wilt u als overheidsorganisatie of semioverheidsorganisatie toegang tot infraplannen.nl? Vraag dan uw uitnodiging aan via één van de deelnemende netbeheerders in uw regio. 
                  In overleg met Stichting Mijn Aansluiting wordt bepaald welke personen binnen uw organisatie de key-user-rol kunnen vervullen.
                </p>`
      },
      {
        question: '5. Hoe zorg ik dat andere organisaties hun plannen ook delen op infraplannen.nl?',
        answer: `<p>
                  Het delen van plannen via infraplannen.nl is niet verplicht. Wel kunt u met andere partijen die werkzaam zijn in de ondergrond in uw regio, het gesprek voeren over het belang ervan. 
                  Heeft u hierbij hulp nodig, bekijk dan de video's en artikelen op <a href="https://www.desamenwerkwijzer.nl" target="_blank" rel="noopener noreferrer">www.desamenwerkwijzer.nl</a> of 
                  neem contact op met onze adviseurs op het gebied van integrale planafstemming <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>.
                </p>`
      },
    ],
  },
];


const PageToegang: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div>
        <header className="page-header container">
          <h1>Toegang tot infraplannen.nl</h1>
          <p className="header-sub-title">Om uw plannen te kunnen delen, vraagt u een uitnodiging aan bij uw netbeheerder.</p>
        </header>

        <section>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Faq data={faqData} />
                  <Button variant="text" color="secondary" onClick={() => navigate('/veelgestelde-vragen')}>
                    Meer veelgestelde vragen
                    <Icon>chevron_right</Icon>
                  </Button>
                </div>
              </div>
            </div>
          </section>
      </div>
    </>
  );
};


export default PageToegang;